import { createElement } from 'react';

const InteractiveDiv = ({
  children,
  handler,
  tabIndex,
  elementType,
  role,
  ...props
}) =>
  createElement(
    elementType,
    {
      onClick: handler,
      onKeyUp: handler,
      tabIndex: tabIndex || '0',
      role,
      ...props
    },
    children
  );

InteractiveDiv.defaultProps = {
  elementType: 'div',
  role: 'button'
};

export default InteractiveDiv;
